/**
 * @generated SignedSource<<1a4247c0ed75852e49b55da2f52bed03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportReactionsStatisticsCardFragment$data = {
  readonly reactionsReport: {
    readonly allTime: number;
    readonly sinceYesterday: number | null;
  };
  readonly " $fragmentType": "MemberReportReactionsStatisticsCardFragment";
};
export type MemberReportReactionsStatisticsCardFragment$key = {
  readonly " $data"?: MemberReportReactionsStatisticsCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportReactionsStatisticsCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportReactionsStatisticsCardFragment",
  "selections": [
    {
      "alias": "reactionsReport",
      "args": [
        {
          "kind": "Literal",
          "name": "kinds",
          "value": [
            "reaction"
          ]
        },
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "userActivityReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sinceYesterday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "21ec227ed12dfa646b6c10ade1f383aa";

export default node;
